<template>
  <component
    v-if="isLoadedData"
    :is="stepModal"
    :propData="propData"
    :isAlreadyAcceptOffer="isAlreadyAcceptOffer"
    :planTimeEnd="planTimeEnd"
    @updatePropData="updatePropData"
    @cancelSubscription="updateProcess"
    @trackEvent="trackEvent"
  />
</template>

<script>
import { mapActions, mapState } from 'vuex'
import * as Sentry from '@sentry/vue'
import Util from '@/util'
import UserApi from '@/api/user'
import {
  CANCEL_SUBSCRIPTION_STEPS,
} from '@/constant/cancelSubscription'
import eventCategories from '@/constant/eventCategories'
import Pricing from '@/pricing'

export default {
  components: {
    ModalRemind: () => import('@/components-v2/my-plan/cancel-subscription/ModalRemind.vue'),
    ModalOptionSelection: () => import('@/components-v2/my-plan/cancel-subscription/ModalOptionSelection.vue'),
    ModalGetOffer: () => import('@/components-v2/my-plan/cancel-subscription/ModalGetOffer.vue'),
    ModalCancelAndFeedback: () => import('@/components-v2/my-plan/cancel-subscription/ModalCancelAndFeedback.vue'),
    ModalSubscriptionCancelled: () => import('@/components-v2/my-plan/cancel-subscription/ModalSubscriptionCancelled.vue'),
  },
  props: {
    subscription: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      stepModal: null,
      propData: {},
      isLoadedData: false,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    isAlreadyAcceptOffer() {
      return this.currentUser
        && this.currentUser.personalInformation
        && this.currentUser.personalInformation.isAlreadyAcceptOffer
    },
    planTimeEnd() {
      // check if user has accepted offer

      if (this.isAlreadyAcceptOffer) {
        return this.subscription
          && this.subscription.metadata
          && this.subscription.metadata.updated_next_billing_date
      }

      return this.currentUser && this.currentUser.planTimeEnd
    },
  },
  async mounted() {
    await this.initWrapperComponent()
  },
  beforeDestroy() {
    this.updateRemoveCardPurposeAction(false)
  },
  methods: {
    ...mapActions(['updateRemoveCardPurposeAction']),
    async getStatistics() {
      const res = await UserApi.getStatistics()
      const stats = (res && res.body) || {}
      const hasWorthStats = stats.eventsHosted
        || stats.participantsEngaged
        || stats.presentationsCreated
        || stats.collaborators

      this.stepModal = hasWorthStats
        ? 'ModalRemind'
        : 'ModalOptionSelection'
      this.propData = stats
    },
    updateProcess(step) {
      switch (step) {
        case CANCEL_SUBSCRIPTION_STEPS.OPTION_SELECTION:
          this.stepModal = 'ModalOptionSelection'
          break
        case CANCEL_SUBSCRIPTION_STEPS.GET_OFFER:
          this.stepModal = 'ModalGetOffer'
          break
        case CANCEL_SUBSCRIPTION_STEPS.CANCEL_AND_GET_FEEDBACK:
          this.stepModal = 'ModalCancelAndFeedback'
          break
        case CANCEL_SUBSCRIPTION_STEPS.CANCELLED:
          this.stepModal = 'ModalSubscriptionCancelled'
          break
        case CANCEL_SUBSCRIPTION_STEPS.END:
          this.$emit('endProcess')
          break
        default:
          this.stepModal = 'ModalRemind'
      }
    },
    updatePropData(objValue) {
      this.propData = {
        ...this.propData,
        ...objValue,
      }
    },
    async initWrapperComponent() {
      try {
        await this.getStatistics()
        this.isLoadedData = true
        this.$emit('endLoading')
      } catch (e) {
        Sentry.captureException(e)
        Util.showToastError(this.$i18nPresenter.t(
          'Something went wrong, please check your connection or contact us for support',
        ))
      }
    },
    trackEvent({
      eventCategory,
      eventAction,
      eventLabel,
      eventValue,
      customProps = {},
    }) {
      const category = eventCategory || eventCategories.MY_PLAN
      const action = eventAction || null
      const label = eventLabel || null
      const value = eventValue || null
      const plan = Pricing.getPlanByType(this.currentUser && this.currentUser.plan)
      const planBillingCycle = plan && plan.billingCycle
      const planGroup = plan && plan.group
      const otherProps = {
        planBillingCycle,
        planGroup,
        ...customProps,
      }

      Util.mixpanelTracking(
        category,
        action,
        label,
        value,
        otherProps,
      )
    },
  },
}
</script>

<style lang="scss">
// global css
.modal-cancel-process {
  .aha-modal__header--text {
    margin-top: 0 !important;
    color: #282E3E !important;
  }

  @media screen and (min-width: 480px) {
    &.modal-cancel-remind {
      .aha-modal__content {
        width: 365px;
      }
    }

    &.modal-cancel-options {
      .aha-modal__content {
        width: 617px;
      }
    }

    &.modal-cancel-offer {
      .aha-modal__content {
        width: 402px;
      }
    }

    &.modal-cancel-feedback {
      .aha-modal__content {
        width: 432px;
      }
    }

    &.modal-cancel-success {
      .aha-modal__content {
        width: 402px;
      }
    }
  }
}
</style>
